import {useContext} from 'react'
import InitialDataContext from './InitialDataContext'

export default function useInitialData() {
  const initialData = useContext(InitialDataContext)
  return initialData
}
